import { Link } from "react-router";

export function SiteFooter() {
  return (
    <footer className="border-t">
      <div className="container flex flex-col gap-4 py-10 md:h-24 md:flex-row md:items-center md:py-0">
        <div className="flex flex-1 items-center space-x-4">
          <img src={"/sendkit-logo.png"} alt="SendKit" className="h-8" />
          <p className="text-sm leading-loose text-muted-foreground">
            © {new Date().getFullYear()} SendKit. All rights reserved.
          </p>
        </div>
        <div className="flex items-center space-x-4">
          <Link
            to="/docs/mcp"
            className="text-sm text-muted-foreground hover:underline underline-offset-4"
          >
            MCP Docs
          </Link>
          <Link
            to="/terms"
            className="text-sm text-muted-foreground hover:underline underline-offset-4"
          >
            Terms
          </Link>
          <Link
            to="/refund-policy"
            className="text-sm text-muted-foreground hover:underline underline-offset-4"
          >
            Refund Policy
          </Link>
          <Link
            to="/contact"
            className="text-sm text-muted-foreground hover:underline underline-offset-4"
          >
            Contact
          </Link>
          <Link
            to="/privacy"
            className="text-sm text-muted-foreground hover:underline underline-offset-4"
          >
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  );
}
